import { StrictMode } from 'react';
import { createRoot } from "react-dom/client";
import { App } from './App';
import { initTelegramApp } from './shared/telegram';
import { BrowserEntryContainer } from './modules/browser-auth/containers/browser-entry-container';
import './shared/ui/game-theme.css';

// Initialize Telegram Mini App SDK before rendering
initTelegramApp();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element not found');
}

createRoot(rootEl).render(
  <StrictMode>
    <BrowserEntryContainer><App /></BrowserEntryContainer>
  </StrictMode>,
);
